import _ from 'lodash';
import { googleViewTypes } from '../../cnr/reducers/GoogleSheetsReducer';
import { dataFix } from '../../common/dataFix';
import { removeFromObject } from '../../common/sorting';
import { deleteAllDocsInCollection } from "../../functions/fbDelete";
import { createRefPath, createRefPath_event } from "./appRefPaths";
import { writeBatch } from 'firebase/firestore';
import { logBatch } from 'global/cnr/reducers/reducerHelpers/logging';

export const _allowRecreateUpdates = true

export const recreateDataHelpers = {
  recreateAllDataCollectionsOneByOne: (state, collectionName, updateTheSettings, updateOnly, allowMerge, showNewOnly, callback) => recreateAllDataCollectionsOneByOne(state, collectionName, updateTheSettings, updateOnly, allowMerge, showNewOnly, callback),
  recreateAllDataCollections: (state, collectionName, updateOnly) => recreateAllDataCollections(state, collectionName, updateOnly),
  recreateDataCollection: (pathViews, collectionKey, dataCollectionData, updateOnly, allowMerge, appDataSource, selectedProp, appDataDocuments) => recreateDataCollection(pathViews, collectionKey, dataCollectionData, updateOnly, allowMerge, appDataSource, selectedProp, appDataDocuments),
  updateCollectionsData: (mainDb, database_fns, pathViews, mergeDataCollections, opts, fn_cls) => updateCollectionsData(mainDb, database_fns, pathViews, mergeDataCollections, opts, fn_cls),
  updateDocumentsData: (pathViews, appDataDocuments, opts) => updateDocumentsData(pathViews, appDataDocuments, opts),
  updateSettingsData: (mainDb, database_fns, pathViews, settings, opts) => updateSettingsData(mainDb, database_fns, pathViews, settings, opts),
}

/**
 * Deletes either a single collection (if `colletionName` is passed in) or each dataCollection in the 'dataCollections` object.
 * @param {*} state 
 * @param {*} collectionName 
 * @param {*} updateTheSettings 
 * @param {*} updateOnly 
 * @param {*} allowMerge 
 * @param {*} showNewOnly 
 * @param {*} callback 
 */
export const recreateAllDataCollectionsOneByOne = async (state, collectionName, updateTheSettings, updateOnly, allowMerge, showNewOnly, callback) => {

  const updateStaticViews = true

  const {
    appDataDocuments,
    appDataSource,
    changedItems,
    googleSheetsPreview,
    dashboardInfo_recreate,
    dataCollection,
    googleActiveDataItems,
    googleViewType,
    newItems,
    pathViews,
    previewStatic,
    selectedProp,
    database_fns,
    appSettings_fns
  } = state ?? {}

  const { projectData } = googleSheetsPreview ?? {}
  const { dataCollections } = projectData ?? {}
  const dataCollectionKeys = _.keys(dataCollections)

  const dcUpdates = initDcUpdates(dataCollectionKeys, collectionName)

  const callback_settings = () => callback(dcUpdates, true)

  const checkDone = (updates) => {
    let done = true
    Object.keys(updates).forEach(key => {
      const update = updates[key]
      if (update.applied && !update.updated) {
        done = false
      }
    })
    if (done) {
      ammendStaticViewsPromise(database_fns, updateStaticViews, pathViews, previewStatic, collectionName).then(res => {
        if (updateTheSettings && dashboardInfo_recreate) {
          const { projectSettings } = dashboardInfo_recreate ?? {}
          appSettings_fns.createNewViewsAndViewItemsSettingsToDb(pathViews, projectSettings, false, callback_settings)
          return false
        } else {
          return done
        }
      })
    }

  }

  // loop the dataCollections
  _.forEach(dataCollectionKeys, collectionKey => {

    let allowUpdate = false

    if (collectionName) {
      if (collectionName === collectionKey) {
        allowUpdate = true
      }
    } else {
      allowUpdate = true
    }

    if (allowUpdate) {

      let _dataCollectionData;

      switch (googleViewType) {
        case googleViewTypes.all:
          _dataCollectionData = dataCollections[collectionKey]
          break;
        case googleViewTypes.changed:
          _dataCollectionData = changedItems
          break;
        case googleViewTypes.new:
          _dataCollectionData = newItems
          break;
        default:
        // nothing
      }

      dcUpdates[collectionKey].applied = true
      dcUpdates[collectionKey].updating = true

      if (selectedProp) {
        const _filteredData = _.mapValues(_dataCollectionData, (dataItem) => {
          if (dataItem[selectedProp]) {
            return { [selectedProp]: dataItem[selectedProp] }; // Include only if the selectedProp exists
          }
          return null
        });
        const _cleanedFilteredData = _.omitBy(_filteredData, _.isNil);
        _dataCollectionData = _cleanedFilteredData
      }

      recreateDataCollection(pathViews, collectionKey, _dataCollectionData, updateOnly, allowMerge, appDataSource, selectedProp, appDataDocuments).then(res => {
        dcUpdates[collectionKey].updating = false
        dcUpdates[collectionKey].updated = true
        callback(dcUpdates, checkDone(dcUpdates))
      })
    }
  })
}

/**
 * inits the dcUpdates
 * @param {*} dataCollectionKeys 
 * @returns dcUpdates
 */
const initDcUpdates = (dataCollectionKeys, collectionName) => {
  const dcUpdates = {}
  dataCollectionKeys.forEach(k => {
    if (collectionName) {
      if (k === collectionName) {
        dcUpdates[k] = { updating: false, updated: false, applied: false }
      }
    } else {
      dcUpdates[k] = { updating: false, updated: false, applied: false }
    }
  })
  return dcUpdates
}

const ammendStaticViewsPromise = async (database_fns, updateStaticViews, pathViews, previewStatic, collectionName) => {
  const promises = []
  if (updateStaticViews) {
    Object.keys(previewStatic).forEach(psKey => {
      let allow = false
      if (collectionName) {
        allow = collectionName === psKey
      }
      const previewStaticItem = previewStatic[psKey]
      const _refPath = createRefPath_event(pathViews, ['staticViews', psKey])
      promises.push(database_fns.set_doc(_refPath, previewStaticItem, null, null, true))
    })
  }
  return Promise.all(promises)
}

export const recreateAllDataCollections = async (state, collectionName, updateOnly) => {
  const { googleSheetsPreview } = state ?? {}
  const { projectData } = googleSheetsPreview ?? {}
  const { dataCollections } = projectData ?? {}
  const dataCollectionKeys = collectionName ? [collectionName] : Object.keys(dataCollections)
  const result = await recreateDataCollections(state, collectionName, updateOnly)
  const items = {}
  if (result) {
    dataCollectionKeys.forEach((k, index) => {
      items[k] = result[index] ? 'Updated ' + result[index].length + ' Document(s)' : "No Documents Updated"
    })
  }
  return items
}

const recreateDataCollections = async (state, collectionName, updateOnly) => {
  const promises = []
  const { pathViews, googleSheetsPreview } = state ?? {}
  const { projectData } = googleSheetsPreview ?? {}
  const { dataCollections } = projectData ?? {}
  if (dataCollections) {
    Object.keys(dataCollections).forEach(collectionKey => {
      if (collectionName) {
        if (collectionKey === collectionName) {
          promises.push(recreateDataCollection(pathViews, collectionKey, dataCollections[collectionKey], updateOnly))
        }
      } else {
        promises.push(recreateDataCollection(pathViews, collectionKey, dataCollections[collectionKey], updateOnly))
      }
    })
  }
  return Promise.all(promises)
}

/**
 * Deletes the data collection and adds the data to a promise
 * @param {object} pathViews 
 * @param {string} collectionKey 
 * @param {object} dataCollectionData 
 * @returns a promise
 */
export const recreateDataCollection = async (pathViews, collectionKey, dataCollectionData, updateOnly, allowMerge, appDataSource, selectedProp, appDataDocuments) => {
  const promises = []
  if (!updateOnly) {
    await deleteAllDocsInCollection(mainDb, pathViews, collectionKey)
    await removeStaticView(pathViews, collectionKey)
  }

  promises.push(addDataCollectionPromise(pathViews, collectionKey, dataCollectionData, updateOnly, allowMerge, appDataSource, selectedProp, appDataDocuments))

  return Promise.all(promises)
}

/**
 * 
 * @param {string} pathViews 
 * @param {object} mergeDataCollections 
 * @param {object} opts 
 * @returns 
 */
export const updateCollectionsData = async (mainDb, database_fns, pathViews, mergeDataCollections, opts, fn_cls) => {

  console.log('***** updateCollectionsData *****')

  const collectionKeys = _.keys(mergeDataCollections); // e.g., ['attendees', 'sessions']

  await Promise.all(collectionKeys.map(collectionKey =>
    batchDeleteAndRecreate_collections(mainDb, database_fns, pathViews, mergeDataCollections, collectionKey, opts, fn_cls)
  ));

  return { success: true, message: "All collections updated successfully." };
};

const batchDeleteAndRecreate_collections = async (mainDb, database_fns, pathViews, mergeDataCollections, collectionKey, opts, fn_cls) => {

  console.log('*** ' + collectionKey + ' ***')

  const updates = []

  const { deletePrior, merge, allowUpdates } = opts ?? {}

  if (deletePrior) {
    // Step 1: Delete all existing documents in the collection
    if (_allowRecreateUpdates && allowUpdates) {
      await fn_cls.deleteEventCollection(pathViews, collectionKey, 100)
    }
  }

  const batch = writeBatch(mainDb);

  // // Step 2: Add new documents
  const newDocs = _.get(mergeDataCollections, collectionKey, {});

  if (_.isEmpty(newDocs)) {
    return { success: true, message: `${collectionKey} had no new documents.` };
  }

  const promises = []
  const _appDataDocs = {}

  _.forEach(newDocs, (data, key) => {
    const cleanedData = dataFix.cleanDocumentData(data, true);
    const _refPath = createRefPath_event(pathViews, [collectionKey, key]);
    _appDataDocs[key] = cleanedData
    // if (_allowRecreateUpdates && allowUpdates) { 
    database_fns.set_doc(_refPath, cleanedData, merge, null, batch)
  });

  if (!_.isEmpty(_appDataDocs)) {
    const _refPath_docs = createRefPath_event(pathViews, ['_documents', collectionKey]);
    // if (_allowRecreateUpdates && allowUpdates) {
    database_fns.set_doc(_refPath_docs, _appDataDocs, merge, null, batch)
  }

  logBatch(batch, _appDataDocs)

  try {
    if (_allowRecreateUpdates && allowUpdates) {
      batch.commit();
    }
    // await Promise.all(promises); // This will wait for all set_doc operations to finish
    console.log(collectionKey + ' test docs', updates)
    console.log(collectionKey + " (" + _.size(promises) + ") documents updated successfully.");
  } catch (error) {
    console.error("Error updating some documents:", error);
    // Handle the error appropriately here
  }

};

export const updateDocumentsData = async (pathViews, appDataDocuments, opts) => {

  console.log('************ updateCollectionsData ************')

  const collectionKeys = _.keys(appDataDocuments); // e.g., ['attendees', 'sessions']

  await Promise.all(collectionKeys.map(collectionKey =>
    batchDeleteAndRecreate_documents(pathViews, appDataDocuments, collectionKey, opts)
  ));

  return { success: true, message: "All collections updated successfully." };
};

const batchDeleteAndRecreate_documents = async (pathViews, appDataDocuments, collectionKey, opts) => {

  // if (deletePrior) {
  //   // Step 1: Delete all existing documents in the collection
  //   await fsfn_deleteEventCollection(pathViews, collectionKey, 100)
  // }

  // // Step 2: Add new documents
  const newDocs = _.get(appDataDocuments, collectionKey, {});

  if (_.isEmpty(newDocs)) {
    return { success: true, message: `${collectionKey} had no new documents.` };
  }

  const promises = []
  const _refPath = createRefPath_event(pathViews, ['_documents', collectionKey]);

  _.forEach(newDocs, (data, key) => {

    console.log('data', _refPath, data)
    // promises.push(database_fns.set_doc(_refPath, cleanedData, null, null, true))
  });

  try {
    await Promise.all(promises); // This will wait for all set_doc operations to finish
    console.log(collectionKey + " documents updated successfully.");
  } catch (error) {
    console.error("Error updating some documents:", error);
    // Handle the error appropriately here
  }

};

export const updateSettingsData = async (mainDb, database_fns, pathViews, settings, opts) => {

  console.log('************ updateSettingsData ************')

  const batch = writeBatch(mainDb);

  const settingsKeys = _.keys(settings); // e.g., ['attendees', 'sessions']

  _.forEach(settingsKeys, settingsKey => {
    const _refPath = createRefPath(['settings', pathViews.events, 'settings', settingsKey]);
    const cleanedData = dataFix.cleanDocumentData(settings[settingsKey]);
    console.log('cleanedData', cleanedData)
    database_fns.set_doc(_refPath, cleanedData, null, null, batch)
  })

  logBatch(batch, settings)

  try {
    if (_allowRecreateUpdates) {
      batch.commit();
    }
    // console.log(settingsKey + " settings updated successfully.");
    return { success: true, message: `Settings updated successfully.` };
  } catch (error) {
    console.error("Error updating some documents:", error);
    return { success: false, message: `Settings not updated successfully.` };
    // Handle the error appropriately here
  }
};

const removeStaticView = async (pathViews, collectionKey) => {
  const _refPath = createRefPath_event(pathViews, ['staticViews', collectionKey])
  await database_fns.delete_doc(_refPath)
}

/**
 * Add a collection based on the collectionKey with the data in dataToUpdate
 * @param {string} collectionKey 
 * @param {object} dataToUpdate 
 * @returns a promise
 */
const addDataCollectionPromise = async (pathViews, collectionKey, dataCollectionData, updateOnly, allowMerge, appDataSource, selectedProp, appDataDocuments) => {

  const _allowCollectionUpdate = true; // Toggle to enable or disable actual updates
  const { useAppDataDocuments, useAppDataDocumentsOnly } = appDataSource ?? {};

  const promises = [];
  const _promises = [];

  const _refPath = createRefPath_event(pathViews, [collectionKey]);

  const addToPromise = (data, _itemKey) => {

    if (data) {

      let _data;

      if (selectedProp) {
        const dataToUpdate = {}
        _.forEach(dataCollectionData, (dataCollectionItem) => {
          dataToUpdate[selectedProp] = dataCollectionItem[selectedProp]
        })
        _data = dataToUpdate
      } else {
        _data = data
      }

      dataFix.removeDeleteFields(_data);
      dataFix.removeAllEmpties(_data);

      removeFromObject(_data, ['id', '_itemKey']);

      const _updatePath = createRefPath([_itemKey], _refPath);
      const updateDetails = { path: _updatePath, data: _data };

      if (updateOnly) {
        if (allowMerge) {
          if (_allowRecreateUpdates) {
            updateDetails.action = "set_doc";
            updateDetails.merge = true;
            if (_allowCollectionUpdate) {
              promises.push(database_fns.set_doc(_updatePath, data, true, null, true));
            }
          } else {
            console.log('_updatePath', _updatePath, data)
          }
        } else {
          if (_allowRecreateUpdates) {
            updateDetails.action = "update_doc";
            if (_allowCollectionUpdate) {
              promises.push(database_fns.update_doc(_updatePath, data, null, true));
            }
          } else {
            console.log('_updatePath', _updatePath, data)
          }
        }
      } else {
        if (_allowRecreateUpdates) {
          updateDetails.action = "set_doc";
          updateDetails.merge = false;
          if (_allowCollectionUpdate) {
            promises.push(database_fns.set_doc(_updatePath, data, null, null, true));
          }
        } else {
          console.log('_updatePath', _updatePath, data)
        }
      }

      _promises.push(updateDetails); // Always log the update details
    }
  };

  if (dataCollectionData) {
    if (useAppDataDocuments) {
      updateDocument(dataCollectionData, pathViews, collectionKey, selectedProp, appDataDocuments);
    }

    if (!useAppDataDocumentsOnly) {
      _.forEach(dataCollectionData, (data, dataKey) => {
        addToPromise(data, dataKey);
      });
    }
  }

  // console.log('_promises', _promises); // Log the collected updates for inspection
  return _allowCollectionUpdate ? Promise.all(promises) : _promises; // Return promises or the collected details

};

const updateDocument = async (dataCollectionData, pathViews, collectionKey, selectedProp, appDataDocuments) => {

  const _appDataDocument = appDataDocuments?.[collectionKey]

  if (selectedProp) {
    const dataToUpdate = {}
    _.forEach(dataCollectionData, (dataCollectionItem, itemKey) => {
      if (_appDataDocument?.[itemKey]) {
        dataToUpdate[itemKey + '.' + selectedProp] = dataCollectionItem[selectedProp]
      }
    })
    const results = await updateDocumentsPromise(pathViews, dataToUpdate, collectionKey, true)
    return results
  } else {

    const documentsData = {};

    await Promise.all(
      _.map(dataCollectionData, async (dataCollectionItem, itemKey) => {
        documentsData[itemKey] = dataCollectionItem
      })
    );

    if (!_.isEmpty(documentsData)) {
      const results = await setDocumentsPromise(pathViews, documentsData, collectionKey, selectedProp)
      console.log('results', results)
      return results
    }

    return

  }
}

const setDocumentsPromise = (pathViews, documentsData, collectionKey, merge) => {
  const promises = []
  const _refPathDoc = createRefPath_event(pathViews, ['_documents', collectionKey])
  promises.push(database_fns.set_doc(_refPathDoc, documentsData, merge))
  return Promise.all(promises)
}

const updateDocumentsPromise = (pathViews, documentsData, collectionKey, merge) => {
  const promises = []
  const _refPathDoc = createRefPath_event(pathViews, ['_documents', collectionKey])
  promises.push(database_fns.update_doc(_refPathDoc, documentsData))
  return Promise.all(promises)
}